<template>
  <div class="news">
    <section class="news-hero">
      <div class="news-hero-bg">
        <img src="/static/xwzx.png" alt="新闻中心">
        <!-- <div class="news-hero-overlay"></div> -->
      </div>
     <!-- <div class="news-hero-content">
        <h1 class="fade-in-up">新闻中心</h1>
        <p class="news-hero-sub fade-in-up delay-1">NEWS CENTER</p>
      </div> -->
    </section>

    <section class="news-filter-section">
      <div class="container">
        <div class="filter-nav" data-aos="fade-up">
          <div
            v-for="cat in categories"
            :key="cat.id"
            role="button"
            tabindex="0"
            :class="['filter-nav-item', { active: activeCategory === cat.id }]"
            @click="handleNavClick(cat.id)"
            @keydown.enter="handleNavClick(cat.id)"
          >
            {{ cat.name }}
          </div>
        </div>
      </div>
    </section>

    <section class="news-list-section">
      <div class="container">
        <div v-if="featuredNews" class="news-featured" data-aos="zoom-in">
          <router-link :to="`/news/detail/${featuredNews.id}`" class="featured-card">
            <div class="featured-image">
              <img :src="featuredNews.image" :alt="featuredNews.title" data-aos="zoom-in">
            </div>
            <div class="featured-content">
              <h2 class="featured-title">{{ featuredNews.title }}</h2>
              <p class="featured-summary">{{ featuredNews.summary }}</p>
              <div class="featured-meta">
                <i class="el-icon-time"></i>
                <span>{{ featuredNews.date }}</span>
              </div>
              <span class="featured-arrow">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </span>
            </div>
          </router-link>
        </div>

        <div class="news-list">
          <div
            v-for="(news, index) in listNews"
            :key="news.id"
            class="news-item"
            data-aos="fade-up"
            :data-aos-delay="(index % 5) * 100"
          >
            <div class="news-date-block">
              <span class="news-day">{{ getDay(news.date) }}</span>
              <span class="news-year-month">{{ getYearMonth(news.date) }}</span>
            </div>
            <div class="news-content">
              <h3 class="news-title">
                <router-link :to="`/news/detail/${news.id}`">{{ news.title }}</router-link>
              </h3>
              <p class="news-summary">{{ news.summary }}</p>
            </div>
            <router-link :to="`/news/detail/${news.id}`" class="news-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </router-link>
          </div>
        </div>

        <div v-if="listNews.length === 0 && !featuredNews" class="news-empty">
          <i class="el-icon-document-delete"></i>
          <p>暂无相关新闻</p>
        </div>

        <div class="news-pagination">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            :total="filteredNews.length"
            layout="total, sizes, prev, pager, next, jumper"
            background
          ></el-pagination>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mockNews } from '@/api/mock'

export default {
  name: 'News',
  data() {
    return {
      newsList: mockNews,
      categories: [
        { id: 'all', name: '新闻中心' },
        { id: 'company', name: '企业动态' },
        { id: 'industry', name: '行业资讯' },
        { id: 'policy', name: '政策法规' }
      ],
      activeCategory: 'all',
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    filteredNews() {
      let result = this.newsList
      
      if (this.activeCategory === 'company') {
        result = result.filter(news => news.category === '公司新闻')
      } else if (this.activeCategory === 'industry') {
        result = result.filter(news => news.category === '行业资讯')
      } else if (this.activeCategory === 'policy') {
        result = result.filter(news => news.category === '政策资讯')
      }
      
      return result
    },
    featuredNews() {
      return this.filteredNews.length > 0 ? this.filteredNews[0] : null
    },
    listNews() {
      const start = (this.currentPage - 1) * this.pageSize
      const list = this.filteredNews.slice(1)
      return list.slice(start, start + this.pageSize - 1)
    }
  },
  mounted() {
    this.syncFromQuery()
  },
  watch: {
    '$route.query.cat'() {
      this.syncFromQuery()
    }
  },
  methods: {
    syncFromQuery() {
      const cat = this.$route.query.cat
      if (cat && this.categories.find(c => c.id === cat)) {
        this.activeCategory = cat
        this.currentPage = 1
      }
    },
    handleNavClick(id) {
      this.activeCategory = id
      this.currentPage = 1
    },
    getDay(dateStr) {
      if (!dateStr) return ''
      const parts = dateStr.split('-')
      return parts[2] ? parts[2] : ''
    },
    getYearMonth(dateStr) {
      if (!dateStr) return ''
      const parts = dateStr.split('-')
      return parts[0] && parts[1] ? parts[0] + '-' + parts[1] : ''
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
    },
    handleCurrentChange(val) {
      this.currentPage = val
    }
  }
}
</script>

<style lang="scss" scoped>
.news-hero {
  position: relative;
  height: 360px;
  overflow: hidden;
}

.news-hero-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.news-hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.6) 0%, rgba(15, 23, 42, 0.75) 100%);
}

.news-hero-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0 8%;
}

.news-hero-content h1 {
  font-size: 52px;
  font-weight: 700;
  color: white;
  margin-bottom: 12px;
  letter-spacing: 4px;
}

.news-hero-sub {
  font-size: 18px;
  color: rgba(255, 255, 255, 0.75);
  letter-spacing: 6px;
  font-weight: 300;
}

.news-filter-section {
  background: white;
  border-bottom: 1px solid #e8ecf1;
}

.filter-nav {
  display: flex;
  align-items: center;
}

.filter-nav-item {
  position: relative;
  padding: 22px 32px;
  font-size: 16px;
  color: #64748b;
  font-weight: 500;
  cursor: pointer;
  transition: color 0.3s ease;
  user-select: none;
  line-height: 1;

  &:hover {
    color: #1a56db;
  }

  &.active {
    color: #1a56db;
    font-weight: 600;

    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 40px;
      height: 3px;
      background: #1a56db;
    }
  }
}

.news-list-section {
  padding: 40px 0 60px;
  background: #f7f9fc;
}

.news-featured {
  margin-bottom: 30px;
}

.featured-card {
  display: flex;
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
  text-decoration: none;
  transition: box-shadow 0.3s ease;

  &:hover {
    box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);

    .featured-title {
      color: #1a56db;
    }

    .featured-arrow {
      background: #1a56db;
      color: white;
    }
  }
}

.featured-image {
  width: 45%;
  flex-shrink: 0;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    min-height: 280px;
  }
}

.featured-content {
  flex: 1;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}

.featured-title {
  font-size: 26px;
  font-weight: 700;
  color: #1e293b;
  margin-bottom: 20px;
  line-height: 1.4;
  transition: color 0.3s ease;
}

.featured-summary {
  font-size: 15px;
  color: #64748b;
  line-height: 1.8;
  margin-bottom: 24px;
}

.featured-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: #94a3b8;

  i {
    font-size: 14px;
  }
}

.featured-arrow {
  position: absolute;
  right: 40px;
  bottom: 40px;
  width: 44px;
  height: 44px;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;

  svg {
    width: 20px;
    height: 20px;
  }
}

.news-list {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.news-item {
  display: flex;
  align-items: center;
  padding: 28px 32px;
  border-bottom: 1px solid #eef2f6;
  transition: background 0.3s ease;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f8fafc;

    .news-title a {
      color: #1a56db;
    }

    .news-arrow {
      background: #1a56db;
      color: white;
    }
  }
}

.news-date-block {
  width: 80px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-right: 24px;
  border-right: 2px solid #e8ecf1;
  margin-right: 24px;
}

.news-day {
  font-size: 42px;
  font-weight: 700;
  color: #1a56db;
  line-height: 1;
  font-family: 'Arial', sans-serif;
}

.news-year-month {
  font-size: 13px;
  color: #94a3b8;
  margin-top: 6px;
}

.news-content {
  flex: 1;
  min-width: 0;
}

.news-title {
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 10px;
  line-height: 1.5;

  a {
    color: inherit;
    text-decoration: none;
    transition: color 0.3s ease;
  }
}

.news-summary {
  font-size: 14px;
  color: #64748b;
  line-height: 1.7;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.news-arrow {
  width: 40px;
  height: 40px;
  background: #f1f5f9;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
  text-decoration: none;

  svg {
    width: 18px;
    height: 18px;
    color: #64748b;
  }
}

.news-empty {
  text-align: center;
  padding: 80px 20px;
  color: #94a3b8;
  background: white;
  border-radius: 8px;

  i {
    font-size: 60px;
    margin-bottom: 20px;
  }

  p {
    font-size: 16px;
  }
}

.news-pagination {
  margin-top: 40px;
  text-align: center;
}

@media (max-width: 992px) {
  .featured-card {
    flex-direction: column;
  }

  .featured-image {
    width: 100%;

    img {
      min-height: 240px;
    }
  }

  .featured-content {
    padding: 30px;
  }

  .featured-arrow {
    right: 30px;
    bottom: 30px;
  }

  .news-hero-content {
    padding: 0 40px;
  }

  .news-hero-content h1 {
    font-size: 40px;
  }

  .filter-nav-item {
    padding: 18px 20px;
    font-size: 15px;
  }

  .news-item {
    padding: 24px 20px;
  }

  .news-date-block {
    width: 64px;
    margin-right: 20px;
    padding-right: 20px;
  }

  .news-day {
    font-size: 34px;
  }
}

@media (max-width: 768px) {
  .news-hero {
    height: 260px;
  }

  .news-hero-content {
    padding: 0 24px;
    align-items: center;
    text-align: center;
  }

  .news-hero-content h1 {
    font-size: 32px;
    letter-spacing: 2px;
  }

  .news-hero-sub {
    font-size: 14px;
    letter-spacing: 4px;
  }

  .filter-nav {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .filter-nav-item {
    padding: 16px 18px;
    font-size: 14px;
    white-space: nowrap;
  }

  .news-list-section {
    padding: 24px 0 40px;
  }

  .featured-content {
    padding: 24px 20px 40px;
  }

  .featured-title {
    font-size: 20px;
  }

  .featured-summary {
    font-size: 14px;
  }

  .featured-arrow {
    right: 20px;
    bottom: 20px;
    width: 36px;
    height: 36px;

    svg {
      width: 16px;
      height: 16px;
    }
  }

  .news-item {
    padding: 20px 16px;
  }

  .news-date-block {
    width: 56px;
    margin-right: 16px;
    padding-right: 16px;
  }

  .news-day {
    font-size: 28px;
  }

  .news-year-month {
    font-size: 12px;
  }

  .news-title {
    font-size: 16px;
  }

  .news-summary {
    font-size: 13px;
    -webkit-line-clamp: 1;
  }

  .news-arrow {
    width: 34px;
    height: 34px;

    svg {
      width: 16px;
      height: 16px;
    }
  }
}
</style>
